import Api from "./Api";
import { debugLog } from "../../utils/debug";

export async function updateUser(firstName, lastName, email) {
    const requestData = {
        id: JSON.parse(sessionStorage.getItem("customer")).user.id,
        firstName: firstName,
        lastName: lastName,
        email: email,
    }

    return Api.post(`/user/update`, requestData)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            // Something went wrong
            if (error.response.data) {
                debugLog("Known error: " + error.response.data);
                this.setState({
                    emailError: "* Email address already registered",
                    formSubmitted: false
                })
            } else {
                debugLog("Got the following error when trying to register a user: " + error.message);
                this.setState({
                    generalError: "Something went wrong, if this persists please contact us",
                    formSubmitted: false
                })
            }
            return null;
        })
}

export function requestPasswordResetForUserId(id) {
    debugLog("Requesting new password: /user/" + id + "/password/reset/request");
    Api.put("/user/" + id + "/password/reset/request")
        .then(res => {
        })
        .catch(error => {
            // // Something went wrong
            // if (error.response.data) {
            //     console.log("Known error: " + error.response.data);
            //     this.setState({
            //         emailError: "* Email address already registered",
            //         formSubmitted: false
            //     })
            // } else {
            //     console.log("Got the following error when trying to register a user: " + error.message);
            //     this.setState({
            //         generalError: "Something went wrong, if this persists please contact us",
            //         formSubmitted: false
            //     })
            // }
        })
}

export function requestPasswordResetForEmail(email) {
    const request = {
        email: email
    }
    return Api.put("/user/password/reset/request", request)
        .then(res => {
            debugLog("Request sent");
            return true;
        })
        .catch(error => {
            // Something went wrong
            debugLog("Got the following error when trying to register a user: " + error.message);
            return false;
            // if (error.response.data) {
            //     console.log("Known error: " + error.response.data);
            //     this.setState({
            //         emailError: "* Email address already registered",
            //         formSubmitted: false
            //     })
            // } else {
            //     console.log("Got the following error when trying to register a user: " + error.message);
            //     this.setState({
            //         generalError: "Something went wrong, if this persists please contact us",
            //         formSubmitted: false
            //     })
            // }
        })
}

export function resetPassword(userId, resetCode, password) {
    const request = {
        resetCode: resetCode,
        password: password
    }
    return Api.put("/user/" + userId + "/password/reset", request)
        .then(res => {
            debugLog("Request sent");
            return true;
        })
        .catch(error => {
            // Something went wrong
            debugLog("Got the following error when trying to register a user: " + error.message);
            return false;
            // if (error.response.data) {
            //     console.log("Known error: " + error.response.data);
            //     this.setState({
            //         emailError: "* Email address already registered",
            //         formSubmitted: false
            //     })
            // } else {
            //     console.log("Got the following error when trying to register a user: " + error.message);
            //     this.setState({
            //         generalError: "Something went wrong, if this persists please contact us",
            //         formSubmitted: false
            //     })
            // }
        })
}

export function sendRegistrationEmail(userId) {
    return Api.put("/user/" + userId + "/registration/send")
        .then(res => {
            debugLog("Request sent");
            return true;
        })
        .catch(error => {
            // Something went wrong
            debugLog("Got the following error when trying to send user verification code: " + error.message);
            return false;
        })
}

export function sendVerificationEmail(userId) {
    return Api.put("/user/" + userId + "/verification/send")
        .then(res => {
            debugLog("Request sent");
            return true;
        })
        .catch(error => {
            // Something went wrong
            console.error("Got the following error when trying to send user verification code: " + error.message);
            return false;
        })
}

export function confirmUserVerification(userId, code) {
    const request = {
        code: code
    }
    return Api.put("/user/" + userId + "/verify", request)
        .then(res => {
            debugLog("Request sent");
            sessionStorage.setItem("customer", JSON.stringify(res.data));
            return true;
        })
        .catch(error => {
            // Something went wrong
            console.error("Got the following error when trying to send user verification code: " + error.message);
            return false;
        })
}